var _linearGradient, _linearGradient2, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 488,
    y2: 45.891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#a163f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#b074ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#d8a1dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#efbad3"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 194,
    x2: 194,
    xlinkHref: "#linear-gradient",
    y1: 488,
    y2: 45.891
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m501 164h-120.455a73.436 73.436 0 0 0 -13.545 1.276v-83.122a22.995 22.995 0 0 0 -23.29-23.223l-175.956 2.552a23.2 23.2 0 0 0 -22.754 23.224v80.569a73.436 73.436 0 0 0 -13.545-1.276h-120.455a5.949 5.949 0 0 0 -6 5.939 44.12 44.12 0 0 0 44.121 44.061h9.079a43.648 43.648 0 0 0 43.7 38h4.906a43.915 43.915 0 0 0 38.194 38.083v139.763a23 23 0 0 0 23.013 23.226h.311l175.939-2.552a23.19 23.19 0 0 0 22.737-23.227v-137.21a43.915 43.915 0 0 0 38.19-38.083h4.91a43.648 43.648 0 0 0 43.7-38h9.08a44.12 44.12 0 0 0 44.12-44.061 5.949 5.949 0 0 0 -6-5.939zm-356 113.919a32.586 32.586 0 0 1 -26.038-25.919h26.038zm0-37.919h-43.1a31.921 31.921 0 0 1 -31.551-26h32.138a6 6 0 0 0 0-12h-53.366a31.928 31.928 0 0 1 -31.559-26h113.893a61.921 61.921 0 0 1 13.545 1.525zm210 187.293a11.124 11.124 0 0 1 -10.927 11.19l-175.957 2.517h-.167a10.792 10.792 0 0 1 -7.74-3.195 10.939 10.939 0 0 1 -3.209-7.959v-345.139a11.124 11.124 0 0 1 10.927-11.19l175.957-2.517h.167a10.792 10.792 0 0 1 7.74 3.195 10.939 10.939 0 0 1 3.209 7.959zm12-149.374v-25.919h26.038a32.586 32.586 0 0 1 -26.038 25.919zm95.879-75.919h-53.37a6 6 0 0 0 0 12h32.138a31.921 31.921 0 0 1 -31.547 26h-43.1v-62.487a62.155 62.155 0 0 1 13.545-1.513h113.893a31.928 31.928 0 0 1 -31.559 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.348 83.705a5.831 5.831 0 0 0 -4.374-1.7h-117.186a5.831 5.831 0 0 0 -4.269 1.6l-23.91 24.246a5.674 5.674 0 0 0 -1.609 4.114v286.875a5.894 5.894 0 0 0 1.573 4.178l23.969 24.966a6.063 6.063 0 0 0 4.246 2.016h117.186a6.2 6.2 0 0 0 4.309-2.018l23.147-24.107a6.128 6.128 0 0 0 1.57-4.275v-287.2a5.66 5.66 0 0 0 -1.506-4.013zm12.652 313.467-19.566 20.828h-112.107l-20.327-21.592v-281.98l20.3-20.428h112.078l19.622 20.773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.333 250h-3.754a20.637 20.637 0 0 0 -20.015-15.093 20.845 20.845 0 0 0 -20.9 20.807 8.9 8.9 0 1 1 -8.9-8.986 6.005 6.005 0 0 0 6-6.006 5.842 5.842 0 0 0 -6-5.812 20.635 20.635 0 0 0 -20.021 15.09h-3.076a6 6 0 0 0 0 12h3.076a21.539 21.539 0 0 0 20.015 14.712 21.008 21.008 0 0 0 20.9-21 8.9 8.9 0 0 1 17.8-.178v.094s0 .065 0 .1a8.907 8.907 0 0 1 -8.9 8.794 6 6 0 0 0 -6 6 6.165 6.165 0 0 0 6 6.19 21.539 21.539 0 0 0 20.021-14.712h3.754a6 6 0 1 0 0-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 182.023a73.6 73.6 0 1 0 73.6 73.6 73.678 73.678 0 0 0 -73.6-73.6zm0 135.191a61.6 61.6 0 1 1 61.6-61.6 61.665 61.665 0 0 1 -61.6 61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 348.1a29.333 29.333 0 1 0 29.333 29.333 29.367 29.367 0 0 0 -29.333-29.333zm0 46.666a17.333 17.333 0 1 1 17.333-17.333 17.353 17.353 0 0 1 -17.333 17.336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 162.178a29.333 29.333 0 1 0 -29.333-29.333 29.367 29.367 0 0 0 29.333 29.333zm0-46.666a17.333 17.333 0 1 1 -17.333 17.333 17.353 17.353 0 0 1 17.333-17.333z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m194 127.153a6 6 0 0 0 6-6v-2.984a6 6 0 1 0 -12 0v2.984a6 6 0 0 0 6 6z",
    fill: "url(#linear-gradient-7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m194 196.132a6 6 0 0 0 6-6v-49.669a6 6 0 1 0 -12 0v49.669a6 6 0 0 0 6 6z",
    fill: "url(#linear-gradient-7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.f6fa67f82da7a81065a773153f5c86f1.svg";
export { ForwardRef as ReactComponent };